import { RepositoryFactory } from 'shared/repositories/RepositoryFactory'
import { AUTH_STORAGE } from '../core/api';

const UserRepository = RepositoryFactory.get('user');

const state = {
  authenticated: null,
  user: null,
  newsletterSubscriptions: null,
  struinenSubscriptions: null,
  annualTickets: [],
  parkingTicketExtensions: []
}

const actions = {
  async get ({ commit }) {
    return new Promise((resolve, reject) => {
      UserRepository.getUser().then(response => {
        const user = response.data;
        commit('SET_AUTHENTICATED', true);
        commit('SET_USER', user);
        resolve(user);
      }).catch((error) => {
        commit('SET_AUTHENTICATED', false);
        commit('SET_USER', null);
        reject(error);
      });
    });
  },
  login ({ commit }, payload) {
    return new Promise((resolve, reject) => {
      UserRepository.login(payload).then(response => {
        const user = response.data.user;
        const apiToken = response.data.api_token;
        localStorage.setItem(AUTH_STORAGE, apiToken);
        commit('SET_AUTHENTICATED', true);
        commit('SET_USER', user);

        GTM.trigger('on_user_login', {
          event: 'loginAccount'
        });

        resolve(user);
      }).catch((error) => {
        localStorage.removeItem(AUTH_STORAGE);
        commit('SET_AUTHENTICATED', false);
        commit('SET_USER', null);
        reject(error);
      });
    })
  },
  logout ({ commit }) {
    return new Promise((resolve, reject) => {
      UserRepository.logout().then(() => {
        localStorage.removeItem(AUTH_STORAGE);
        commit('SET_AUTHENTICATED', false);
        commit('SET_USER', null);
        resolve(true);
      }).catch((error) => {
        localStorage.removeItem(AUTH_STORAGE);
        commit('SET_AUTHENTICATED', false);
        commit('SET_USER', null);
        reject(error);
      });
    })
  },
  requestResetPassword ({ commit }, payload) {
    return new Promise((resolve, reject) => {
      UserRepository.requestResetPassword(payload).then(response => {
        resolve(response)
      }).catch((error) => {
        reject(error);
      });
    });
  },
  resetPassword ({ commit }, payload) {
    return new Promise((resolve, reject) => {
      UserRepository.resetPassword(payload).then(response => {
        const user = response.data.user;
        const apiToken = response.data.api_token;
        localStorage.setItem(AUTH_STORAGE, apiToken);
        commit('SET_AUTHENTICATED', true);
        commit('SET_USER', user);
        resolve(user);
      }).catch((error) => {
        reject(error);
      });
    });
  },
  signUp ({ commit }, payload) {
    return new Promise((resolve, reject) => {
      UserRepository.signUp(payload).then(response => {
        GTM.trigger('on_account_created');

        const user = response.data;
        resolve(user);
      }).catch((error) => {
        reject(error);
      });
    })
  },
  verify ({ commit }, payload) {
    return new Promise((resolve, reject) => {
      UserRepository.verify(payload).then(response => {
        const user = response.data.user;
        const apiToken = response.data.api_token;
        localStorage.setItem(AUTH_STORAGE, apiToken);
        commit('SET_AUTHENTICATED', true);
        commit('SET_USER', user);
        resolve(user);
      }).catch((error) => {
        reject(error);
      });
    })
  },
  resendVerificationEmail ({ commit }, payload) {
    return new Promise((resolve, reject) => {
      UserRepository.resendVerificationEmail(payload).then(() => {
        resolve(true);
      }).catch((error) => {
        reject(error);
      });
    })
  },
  requestFacebookDisconnect ({ commit }, payload) {
    return new Promise((resolve, reject) => {
      UserRepository.requestFacebookDisconnect(payload).then(() => {
        resolve(true);
      }).catch((error) => {
        reject(error);
      });
    })
  },
  facebookDisconnect ({ commit }, payload) {
    return new Promise((resolve, reject) => {
      UserRepository.facebookDisconnect(payload).then(response => {
        const user = response.data.user;
        const apiToken = response.data.api_token;
        const resetPasswordCode = response.data.reset_password_code;
        localStorage.setItem(AUTH_STORAGE, apiToken);
        commit('SET_AUTHENTICATED', true);
        commit('SET_USER', user);
        const payload = {
          user,
          resetPasswordCode
        }
        resolve(payload);
      }).catch((error) => {
        reject(error);
      });
    })
  },
  update ({ commit }, payload) {
    return new Promise((resolve, reject) => {
      UserRepository.update(payload).then(response => {
        const user = response.data;
        commit('SET_USER', user);
        resolve(user);
      }).catch((error) => {
        reject(error);
      });
    })
  },
  delete ({ commit }, userId) {
    return new Promise((resolve, reject) => {
      UserRepository.delete(userId).then(response => {
        const user = response.data;
        resolve(user);
      }).catch((error) => {
        reject(error);
      });
    })
  },
  async getStruinenSubscriptions ({ commit }) {
    return new Promise((resolve, reject) => {
      UserRepository.getStruinenSubscriptions().then(response => {
        const subscriptions = response.data;
        commit('SET_STRUINEN_SUBSCRIPTIONS', subscriptions);
        resolve(subscriptions);
      }).catch((error) => {
        reject(error);
      });
    })
  },
  async getNewsletterSubscriptions ({ commit }) {
    return new Promise((resolve, reject) => {
      UserRepository.getNewsletterSubscriptions().then(response => {
        const subscriptions = response.data;
        commit('SET_NEWSLETTER_SUBSCRIPTIONS', subscriptions);
        resolve(subscriptions);
      }).catch((error) => {
        reject(error);
      });
    })
  },
  async postStruinenSubscriptions ({ commit }) {
    return new Promise((resolve, reject) => {
      UserRepository.postStruinenSubscriptions().then(response => {
        resolve(response);
      }).catch((error) => {
        reject(error);
      });
    })
  },
  async postNewsletterSubscriptions ({ commit }) {
    return new Promise((resolve, reject) => {
      UserRepository.postNewsletterSubscriptions().then(response => {
        resolve(response);
      }).catch((error) => {
        reject(error);
      });
    })
  },
  async deleteStruinenSubscriptions ({ commit }) {
    return new Promise((resolve, reject) => {
      UserRepository.deleteStruinenSubscriptions().then(response => {
        resolve(response);
      }).catch((error) => {
        reject(error);
      });
    })
  },
  async deleteNewsletterSubscriptions ({ commit }) {
    return new Promise((resolve, reject) => {
      UserRepository.deleteNewsletterSubscriptions().then(response => {
        resolve(response);
      }).catch((error) => {
        reject(error);
      });
    })
  },
  async getAnnualTickets ({ commit }) {
    return new Promise((resolve, reject) => {
      UserRepository.getAnnualTickets().then(response => {
        const tickets = response.data;
        commit('SET_ANNUAL_TICKETS', tickets);
        resolve(response);
      }).catch((error) => {
        reject(error);
      });
    })
  },
  async getParkingTicketExtensions ({ commit }) {
    return new Promise((resolve, reject) => {
      UserRepository.getParkingTicketExtensions().then(response => {
        const tickets = response.data;
        commit('SET_PARKING_TICKET_EXTENSIONS', tickets);
        resolve(response);
      }).catch((error) => {
        reject(error);
      });
    })
  }
}

const mutations = {
  SET_USER (state, user) {
    state.user = user;
    window.currentUser = user; // required for legacy upload
  },
  SET_AUTHENTICATED (state, isAuthenticated) {
    state.authenticated = isAuthenticated;
  },
  SET_NEWSLETTER_SUBSCRIPTIONS (state, subscriptions) {
    state.newsletterSubscriptions = subscriptions;
  },
  SET_STRUINEN_SUBSCRIPTIONS (state, subscriptions) {
    state.struinenSubscriptions = subscriptions;
  },
  SET_ANNUAL_TICKETS (state, annualTickets) {
    state.annualTickets = annualTickets;
  },
  SET_PARKING_TICKET_EXTENSIONS (state, parkingTicketExtensions) {
    state.parkingTicketExtensions = parkingTicketExtensions;
  }
}

const getters = {
  isAuthenticated (state) {
    return state.authenticated && typeof state.user === 'object';
  },
  userId (state) {
    const user = state.user;
    return (user && typeof user === 'object' ? user.id : null);
  },
  user (state) {
    return state.user
  },
  newsletterSubscriptions (state) {
    return state.newsletterSubscriptions
  },
  struinenSubscriptions (state) {
    return state.struinenSubscriptions
  },
  annualTickets (state) {
    return state.annualTickets
  },
  parkingTicketExtensions (state) {
    return state.parkingTicketExtensions
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
